import src from "IMAGE";
export default { src, width: 302, height: 64, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAMbN1wCEydCAg4bKwELFiMBChQfAQoUHxQMDB8jDgUgAAMaM1QCEyU+Ag0aKQIRITQCECAzAg8eLhsREi0zFAguz58GaA8xZ3UAAAAASUVORK5CYII="};
